/**
 * Created by tomers on 12/27/2016.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var GraphQLCollection = require("collections/GraphQLCollection");
    var ApiResources = require("assets/data/apiResources.json");
    var AuditTrailModel = require("manager-models/audit-trail/AuditTrailModel");
    var AuditTrailExportModel = require("manager-models/audit-trail/AuditTrailExportModel");

    var MAX_RECORDS_FOR_EXPORT = 100000;

    var NAME = "AuditTrailCollection";

    var FILTERS_ENUM = {
        LANGUAGE: "language",
        TIMEZONE: "timezone",
        COMPONENT_TYPES: "componentTypes",
        USERS: "users",
        FULL_USERS: "fullUsers",
        FROM_DATE: "fromDate",
        TO_DATE: "toDate",
        CHANGE_DATE: "changeDate",
        INCLUDE_LPA: "lpa",
        INCLUDE_AUTOMATIC_UPDATES: "automaticUpdates",
        EXPORT_LIMIT: "limit"
    };

    var ADDITIONAL_FILTER_USERS = [
        FILTERS_ENUM.INCLUDE_LPA,
        FILTERS_ENUM.INCLUDE_AUTOMATIC_UPDATES
    ];

    var EXPORT_FILTERS = [
        FILTERS_ENUM.LANGUAGE,
        FILTERS_ENUM.TIMEZONE,
        FILTERS_ENUM.COMPONENT_TYPES,
        FILTERS_ENUM.USERS,
        FILTERS_ENUM.FROM_DATE,
        FILTERS_ENUM.TO_DATE,
        FILTERS_ENUM.INCLUDE_LPA,
        FILTERS_ENUM.INCLUDE_AUTOMATIC_UPDATES,
        FILTERS_ENUM.EXPORT_LIMIT
    ];

    var AuditTrailCollection = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        AuditTrailCollection = GraphQLCollection.extend({
            FILTERS_ENUM: FILTERS_ENUM,
            OBJECT_TYPES: AuditTrailModel.OBJECT_TYPES,
            model: AuditTrailModel,
            resource: ApiResources.AccountConfig.AuditTrail,
            name: NAME,
            internalFilters: [FILTERS_ENUM.FULL_USERS, FILTERS_ENUM.CHANGE_DATE, FILTERS_ENUM.EXPORT_LIMIT],
            responseParams: [
                AuditTrailModel.KEYS.OBJECT_TYPE,
                AuditTrailModel.KEYS.OBJECT_NAME,
                AuditTrailModel.KEYS.ACTION_TYPE,
                AuditTrailModel.KEYS.ELEMENT,
                AuditTrailModel.KEYS.OLD_VALUE,
                AuditTrailModel.KEYS.NEW_VALUE,
                AuditTrailModel.KEYS.CHANGE_DATE,
                AuditTrailModel.KEYS.ORIGINATOR,
                AuditTrailModel.KEYS.ORIGINATOR_LOGIN_NAME,
                AuditTrailModel.KEYS.DISPLAY_TYPE
            ],

            initialize: function(models, options) {
                GraphQLCollection.prototype.initialize.call(this, models, options);

                this.setOrderBy(AuditTrailModel.KEYS.CHANGE_DATE, {fetchOnChange: false});
                this.setOrderDirection(GraphQLCollection.ORDER_DIRECTION.DESC, {fetchOnChange: false});
                this.setFilterValue(FILTERS_ENUM.EXPORT_LIMIT, MAX_RECORDS_FOR_EXPORT, {fetchOnChange: false});
            },

            /**
             * When setting one of the internal filters (full users or date) we need to convert it to a "real" filter that GraphQL server knows (users, from date, to date)
             * @param filterName
             * @param filterValue
             * @param options
             */
            setFilterValue: function(filterName, filterValue, options) {
                if (filterName === FILTERS_ENUM.FULL_USERS) {
                    var usersFilterValue = _.map(filterValue, function(item) {
                        return item.id.toString();
                    });

                    var includeLPA = (_.contains(usersFilterValue, FILTERS_ENUM.INCLUDE_LPA)) ? true : null; // if it doesnt contain we are setting to NULL because if it's null we don't send it to the backend in the query
                    var includeAutomaticUpdates = (_.contains(usersFilterValue, FILTERS_ENUM.INCLUDE_AUTOMATIC_UPDATES)) ? true : null; // if it doesnt contain we are setting to NULL because if it's null we don't send it to the backend in the query
                    usersFilterValue = _.difference(usersFilterValue, ADDITIONAL_FILTER_USERS); // The real users filter should not contain lpa and automaticUpdates (additional filter users) so we need to exclude this from the array

                    this.setFilterValue(FILTERS_ENUM.USERS, usersFilterValue, {fetchOnChange:false});
                    this.setFilterValue(FILTERS_ENUM.INCLUDE_LPA, includeLPA, {fetchOnChange:false});
                    this.setFilterValue(FILTERS_ENUM.INCLUDE_AUTOMATIC_UPDATES, includeAutomaticUpdates, {fetchOnChange:false});
                }

                if (filterName === FILTERS_ENUM.CHANGE_DATE) {
                    var fromDate = filterValue.startDate || null;
                    if (fromDate) {
                        fromDate = fromDate.split(" ")[0]; // we need to take the date only without the hour
                    }
                    var toDate = filterValue.expirationDate || null;
                    if (toDate) {
                        toDate = toDate.split(" ")[0]; // we need to take the date only without the hour
                    }



                    this.setFilterValue(FILTERS_ENUM.FROM_DATE, fromDate, {fetchOnChange:false});
                    this.setFilterValue(FILTERS_ENUM.TO_DATE, toDate, {fetchOnChange:false});
                }

                GraphQLCollection.prototype.setFilterValue.call(this, filterName, filterValue, options);
            },

            /**
             * Exporting is part of the collection because it needs to use the filters
             * @param options
             */
            exportAuditTrail: function(options) {
                options = options || {};
                options.data = options.data || {};

                _.each(EXPORT_FILTERS, _.bind(function(filterName) {
                    var filterValue = this.getFilterValue(filterName);
                    if (_.isArray(filterValue)) {
                        filterValue = filterValue.join(",");
                    }

                    if (!_.isUndefined(filterValue) && !_.isNull(filterValue) && filterValue !== "") {
                        options.data[filterName] = filterValue;
                    }
                }, this));

                var exportModel = new AuditTrailExportModel();
                exportModel.fetch(options);
            }
        });

    }

    LE.module("LEManager", moduleDefinition);

    AuditTrailCollection.NAME = NAME;
    AuditTrailCollection.FILTERS_ENUM = FILTERS_ENUM;

    return AuditTrailCollection;
});
